import { defineLabels, resolveLabels } from "@nexus/widget-sdk";

export const EVENT_PROTECTION_LABELS = defineLabels([
  { key: "emptyTitle", name: "Empty state title", default: "No events" },
  {
    key: "emptyDescription",
    name: "Empty state description",
    default: "There is no campaign event to display.",
  },
  { key: "engine", name: "Engine column heading", default: "Engine" },
  { key: "detection", name: "Detection group heading", default: "Detection" },
  { key: "response", name: "Response group heading", default: "Response" },
  { key: "monitor", name: "Monitor button", default: "Monitor" },
  {
    key: "noEngineConfig",
    name: "No engine configuration text",
    default: "No engine configuration for this event.",
  },
] as const);

export type EventProtectionLabels = ReturnType<
  typeof resolveLabels<typeof EVENT_PROTECTION_LABELS>
>;
export const DEFAULT_EVENT_PROTECTION_LABELS: EventProtectionLabels = resolveLabels(
  EVENT_PROTECTION_LABELS,
  undefined,
);
